import i18n from '@/plugins/i18n';
import { DateTime } from 'luxon';
import { isValid24HourTime } from '../../../components/utils/utils';

/**
 * Returns a function to validate time is at or after minTime
 * @param {string} minTime - Minimum allowed time in HH:mm format
 */
export function createTimeRule({ item, fieldType, firstPastDay, toUTCFromLocalDateTime }) {
	return (v) => {
		if (!v) return true;
		if (!isValid24HourTime(v)) return i18n.t('time_invalid');
		if (fieldType === 'start' && v && !item.endTime) {
			return i18n.t('planning_duty_details_please_choose_time');
		}
		if (fieldType === 'end' && v && !item.startTime) {
			return i18n.t('planning_duty_details_please_choose_time');
		}
		if (!firstPastDay?.operatingDayStart) return true;

		const firstPastMillis = DateTime.fromISO(firstPastDay.operatingDayStart).toMillis();

		if (fieldType === 'start') {
			if (!item.startDate) return true;
			const startMillis = toUTCFromLocalDateTime(item.startDate, v).toMillis();
			return startMillis >= firstPastMillis || i18n.t('time_after_locked');
		}

		if (fieldType === 'end') {
			if (!item.endDate) return true;
			const startMillis = toUTCFromLocalDateTime(item.startDate, item.startTime).toMillis();
			const endMillis = toUTCFromLocalDateTime(item.endDate, v).toMillis();

			if (startMillis >= firstPastMillis) {
				return endMillis >= startMillis || i18n.t('time_after_start');
			}
			return endMillis >= firstPastMillis || i18n.t('time_after_locked');
		}

		return true;
	};
}
